import { render } from "./ViewHome.vue?vue&type=template&id=06f6614c&scoped=true"
import script from "./ViewHome.vue?vue&type=script&lang=js"
export * from "./ViewHome.vue?vue&type=script&lang=js"

import "./ViewHome.vue?vue&type=style&index=0&id=06f6614c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f6614c"]])

export default __exports__